import './style.css';
const Progress = () => {
  return (
    <div className="progress">
      <div className="progress-bar">
        <div className="progress-bar-value"></div>
      </div>
    </div>
  );
};

export default Progress;
